import { render, staticRenderFns } from "./CollegeMember.vue?vue&type=template&id=3196ded0&"
import script from "./CollegeMember.vue?vue&type=script&lang=js&"
export * from "./CollegeMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports